
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"rgba(37, 99, 235, 1)","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.075 10.038v2.642H1.188A1.19 1.19 0 010 11.49V4.755h11.095l-5.02 5.283zm4.597-3.7a.166.166 0 01.245 0l1.604 1.719a.196.196 0 010 .262L8.64 12.48l-1.65.197c-.221.026-.407-.173-.383-.41L6.79 10.5l3.883-4.161zM1.882 9.51a.298.298 0 00-.297.297v.99c0 .163.134.297.297.298H3.93a.299.299 0 00.297-.298v-.99a.298.298 0 00-.297-.297H1.882zm0-3.17a.298.298 0 00-.297.297v.99c0 .163.134.298.297.298h3.104c.162 0 .295-.293.297-.298v-.99a.298.298 0 00-.297-.297H1.882zm10.066-1.368a.663.663 0 01.982 0l.868.93c.27.289.27.76 0 1.051l-.63.675a.166.166 0 01-.245 0l-1.604-1.719a.196.196 0 010-.263l.63-.674zM3.566 0c.218 0 .396.179.396.396v1.189h3.17V.396C7.132.18 7.31 0 7.528 0h.792c.218 0 .397.179.397.396v1.189h1.188c.657 0 1.19.532 1.19 1.188v1.189H0V2.773a1.19 1.19 0 011.188-1.188h1.189V.396c0-.217.179-.396.396-.396h.793z"}})])
          )
        }
      }
    